






import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class Card extends Vue {
    @Prop({ type: String, default: 'white' }) readonly background!: boolean
    @Prop({ type: Boolean, default: true }) readonly shadow!: boolean
    @Prop({ type: Boolean, default: true }) readonly rounded!: boolean
    @Prop({ type: Number, default: 1 }) readonly span!: number

    get componentClass() {
        return {
            'card': true,
            'card--with-shadow': this.shadow,
            'card--with-rounded-corners': this.rounded,
            ['card--background-' + this.background]: true,
        }
    }

    get variables() {
        return {
            '--card-span': this.span,
        }
    }
}


